import Shorcuts from './Shorcuts';

export default Shorcuts;
